/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React from 'react';
import classNames from 'classnames';
import Box from '@material-ui/core/Box';
import { Typography, Button } from '@material-ui/core';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import CloseIcon from '@material-ui/icons/Close';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import RestoreIcon from '@material-ui/icons/Restore';
// import Brightness2Icon from '@material-ui/icons/Brightness2';

import { startEndTimeDisplay, parseDateUtc } from '../../../../utils/dates';
import { VisitType } from '../../../../enums';
import { cardTypes } from '../../../../settings/constants/cardTypes';

export default function PatientActivity({
  assignment,
  isFiltered,
  containerClass,
  schedulerPeriod,
  flags,
  handleAssignmentFunc,
  unAssignClinicianFunc,
}) {
  const time =
    flags.isCompletedVisit || flags.isAhead || flags.isStartedLate
      ? assignment.actualOccurance.visual
      : flags.isClinicianRowActive
      ? assignment.visitTime.visual
      : assignment.totalTime.visual;
  const actualTime =
    flags.isCompletedVisit || flags.isAhead || flags.isStartedLate
      ? assignment.actualOccurance.actual
      : flags.isClinicianRowActive
      ? assignment.visitTime.actual
      : assignment.totalTime.actual;
  const duration = time.duration;
  const startTime = time.startDate;
  const hasVisualTravelDuration =
    flags.showTravelTime &&
    assignment.travelTime.visual.duration > 0 &&
    !flags.isClinicianRowActive &&
    !flags.isBehindNow &&
    !flags.isCompletedVisit &&
    !flags.isAhead &&
    !flags.isStartedLate;
  const showContent = duration > 5;
  const showPatientAssignmentContent =
    showContent && (flags.showTravelTime ? parseDateUtc(actualTime.startDate).isBefore(schedulerPeriod.endDate) : true);

  const isCard33 = assignment.overlapGroupIndex >= 3;
  const isCard50 = assignment.overlapGroupIndex >= 1 && assignment.overlapGroupIndex <= 2;
  const reduceView = isCard33 || isCard50;
  const assignmentContentClass = classNames('visit-content', {
    'visit-empty-content': !showPatientAssignmentContent && !flags.isBehindNow && duration >= 10,
    'is-behind-now': flags.isBehindNow,
  });
  const containerClassExtend = classNames(containerClass, {
    'no-padding': !showContent,
    'card-50': isCard50,
    'second-half': isCard50 && assignment.overlapIndex === 2,
    'card-33': isCard33,
    'one-thirds': isCard33 && assignment.overlapIndex === 2,
    'two-thirds': isCard33 && assignment.overlapIndex === 3,
    'filtered-assignment': isFiltered,
  });

  const onClickVisit = () => handleAssignmentFunc(assignment, flags.isPlannedVisit || flags.isBehindNow);

  const showMileageCapIconOnShorterVisit = flags.isBundled
    ? !hasVisualTravelDuration && flags.isOutsideOfMileageCap && showContent
    : !hasVisualTravelDuration && flags.isOutsideOfMileageCap;

  const showMileageCapIconOnLongerVisit = flags.isBundled
    ? hasVisualTravelDuration &&
      flags.isOutsideOfMileageCap &&
      (assignment.visitTime.visual.duration > 5 || assignment.visitTime.actual.duration > 5)
    : hasVisualTravelDuration && flags.isOutsideOfMileageCap;

  return duration === 0 ? null : (
    <div
      key={`pa_${assignment.index}`}
      className={containerClassExtend}
      data-id={assignment.id}
      data-start-datetime={startTime}
      data-duration={duration}
      style={{ opacity: isFiltered ? '0.4' : '1' }}
    >
      {flags.isEditMode && (flags.isPlannedVisit || flags.isBehindNow) && (
        <Button className="cancel-btn" aria-label="Cancel" size="small" onClick={unAssignClinicianFunc}>
          <CloseIcon fontSize="small" style={{ color: '#fff' }} />
        </Button>
      )}
      {showContent && hasVisualTravelDuration && (
        <Box
          className="visit-travel-section"
          data-duration={assignment.travelTime.visual.duration}
          display="flex"
          justifyContent="center"
          alignItems="center"
          onClick={onClickVisit}
        >
          <Box>
            {!reduceView && <DirectionsCarIcon fontSize="small" />}
            <Typography variant="subtitle2" display="block">
              {`${assignment.travelTime.actual.duration} min`}
            </Typography>
          </Box>
        </Box>
      )}

      <div className={assignmentContentClass} onClick={onClickVisit}>
        <Box display="flex" flexDirection="row">
          {assignment.visitType === VisitType.PhoneCall && duration >= 10 && (
            <Box
              className="visit-phone-icon"
              display="flex"
              justifyContent="center"
              alignItems="center"
              onClick={onClickVisit}
            >
              <span className="icon-extend icon-on-call" />
            </Box>
          )}
          {showContent && (
            <Box display="flex" flexDirection="column" className="ellipsis">
              <Typography className="ellipsis" variant="subtitle2">
                {assignment.secondaryLabel}
              </Typography>
              {!isCard33 && (
                <React.Fragment>
                  <Typography className="ellipsis" variant="h5">
                    {assignment.primaryLabel}
                  </Typography>
                  <Box display="flex" alignItems="center" className="ellipsis">
                    {!flags.isCompletedVisit && assignment.runsOvernight && (
                      <div className="icon-container night-shift-icon">
                        <span className="icon-extend icon-night icon-xsmall" />
                      </div>
                    )}
                    <Typography className="ellipsis mx-display-flex" variant="subtitle2">
                      {startEndTimeDisplay(actualTime.startDate, actualTime.endDate)}
                    </Typography>
                  </Box>
                  <Box display="flex" flexDirection="row">
                    {assignment.visitType === VisitType.PhoneCall ? (
                      <Typography className="time-travel ellipsis" variant="subtitle2" display="block">
                        {assignment.contactNumber}
                      </Typography>
                    ) : (
                      !hasVisualTravelDuration &&
                      !flags.isCompletedVisit && (
                        <Typography className="time-travel ellipsis" variant="subtitle2" display="block">
                          <DirectionsCarIcon fontSize="small" />
                          {assignment.travelTime.actual.duration} min
                        </Typography>
                      )
                    )}
                    {showMileageCapIconOnLongerVisit && (
                      <div className="icon-container icon-mileage-cap">
                        <span className="icon-extend icon-radius icon-small" />
                      </div>
                    )}
                    {flags.isBundled && (
                      <div className="icon-container icon-bundle">
                        <span className="icon-extend icon-bundle-visits icon-small" />
                      </div>
                    )}
                    {assignment.isReviewDate && (
                      <Typography className="time-travel ellipsis" variant="subtitle2" display="block">
                        <span className="icon-review icon-svg asw-icon review-date" />
                      </Typography>
                    )}
                    {flags.isCompletedVisit && (
                      <Typography className="time-travel ellipsis" variant="subtitle2" display="block">
                        <DoneAllIcon fontSize="small" />
                      </Typography>
                    )}
                    {assignment.cardType === cardTypes.RETROSPECTIVE_VISIT && (
                      <Typography className="time-travel ellipsis" variant="subtitle2">
                        <RestoreIcon fontSize="small" />
                      </Typography>
                    )}
                  </Box>
                </React.Fragment>
              )}
            </Box>
          )}
        </Box>
      </div>
      <div className="icon-container timeline-assignment-left-icon">
        {showMileageCapIconOnShorterVisit && (
          <div className="icon-mileage-cap">
            {/* Visits that break rules AutoAllocate or manually icons 
            <span className="icon-extend icon-warning-outline icon-small p-x-4" />
            <span className="icon-extend icon-warning-filled icon-small p-x-4" /> */}
            <span className="icon-extend icon-radius icon-small" />
          </div>
        )}
        {flags.isBundled && !showContent && (
          <div className="icon-bundle">
            <span className="icon-extend icon-bundle-visits icon-small" />
          </div>
        )}
      </div>
      {assignment.visitType === VisitType.PhoneCall && duration < 10 && (
        <div className="icon-container timeline-assignment-icon" onClick={isCard33 || isCard50 ? onClickVisit : null}>
          <span className="icon-extend icon-on-call" />
        </div>
      )}
    </div>
  );
}
